import type { TourChapterDef } from '../types';
import { s } from './sharedSteps';

export const ownerChapters: TourChapterDef[] = [
  {
    id: 'owner.dashboard',
    titleKey: 'dashboard',
    route: '/dashboard',
    useSampleData: true,
    steps: [
      s('[data-tour="dashboard-filters"]', 'tour.ch.dashboard.filters.title', 'tour.ch.dashboard.filters.body', '/dashboard', { placement: 'bottom' }),
      s('[data-tour="dashboard-stats"]', 'tour.ch.dashboard.stats.title', 'tour.ch.dashboard.stats.body', '/dashboard', { placement: 'bottom' }),
      s('[data-tour="dashboard-activity"]', 'tour.ch.dashboard.activity.title', 'tour.ch.dashboard.activity.body', '/dashboard', { placement: 'right' }),
      s('[data-tour="dashboard-upcoming"]', 'tour.ch.dashboard.upcoming.title', 'tour.ch.dashboard.upcoming.body', '/dashboard', { placement: 'left' }),
      s('[data-tour="navbar-credits"]', 'tour.ch.dashboard.credits.title', 'tour.ch.dashboard.credits.body', '/dashboard', { placement: 'bottom' }),
    ],
  },
  {
    id: 'owner.reports',
    titleKey: 'reports',
    route: '/reports',
    useSampleData: true,
    steps: [
      s('[data-tour="reports-categories"]', 'tour.ch.reports.cats.title', 'tour.ch.reports.cats.body', '/reports', { placement: 'right' }),
      s('[data-tour="reports-segments"]', 'tour.ch.reports.seg.title', 'tour.ch.reports.seg.body', '/reports', { placement: 'bottom' }),
      s('[data-tour="reports-filters"]', 'tour.ch.reports.filters.title', 'tour.ch.reports.filters.body', '/reports', { placement: 'bottom' }),
      s('[data-tour="reports-export"]', 'tour.ch.reports.export.title', 'tour.ch.reports.export.body', '/reports', { placement: 'left' }),
    ],
  },
  {
    id: 'owner.shifts',
    titleKey: 'shifts',
    route: '/shifts',
    useSampleData: true,
    steps: [
      s('[data-tour="shifts-view-toggle"]', 'tour.ch.shifts.view.title', 'tour.ch.shifts.view.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="shifts-filters"]', 'tour.ch.shifts.filters.title', 'tour.ch.shifts.filters.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="shifts-fill-rate"]', 'tour.ch.shifts.fill.title', 'tour.ch.shifts.fill.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="shifts-presets"]', 'tour.ch.shifts.presets.title', 'tour.ch.shifts.presets.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="shifts-create"]', 'tour.ch.shifts.create.title', 'tour.ch.shifts.create.body', '/shifts', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.shifts.create.panel.title', 'tour.ch.shifts.create.panel.body', '/shifts', {
        placement: 'left',
        openSlideOver: 'create-shift',
      }),
      s('[data-tour="shifts-list"]', 'tour.ch.shifts.list.title', 'tour.ch.shifts.list.body', '/shifts', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.attendance',
    titleKey: 'attendance.requests',
    route: '/attendance-requests',
    useSampleData: true,
    steps: [
      s('[data-tour="attendance-tabs"]', 'tour.ch.attendance.tabs.title', 'tour.ch.attendance.tabs.body', '/attendance-requests', { placement: 'bottom' }),
      s('[data-tour="attendance-list"]', 'tour.ch.attendance.list.title', 'tour.ch.attendance.list.body', '/attendance-requests', { placement: 'top' }),
      s('[data-tour="attendance-actions"]', 'tour.ch.attendance.actions.title', 'tour.ch.attendance.actions.body', '/attendance-requests', { placement: 'left' }),
    ],
  },
  {
    id: 'owner.vacation',
    titleKey: 'vacation',
    route: '/vacation',
    useSampleData: true,
    steps: [
      s('[data-tour="vacation-kpis"]', 'tour.ch.vacation.kpi.title', 'tour.ch.vacation.kpi.body', '/vacation', { placement: 'bottom' }),
      s('[data-tour="vacation-form"]', 'tour.ch.vacation.form.title', 'tour.ch.vacation.form.body', '/vacation', { placement: 'right' }),
      s('[data-tour="vacation-list"]', 'tour.ch.vacation.list.title', 'tour.ch.vacation.list.body', '/vacation', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.announcements',
    titleKey: 'announcements',
    route: '/announcements',
    useSampleData: true,
    steps: [
      s('[data-tour="announcements-compose"]', 'tour.ch.ann.compose.title', 'tour.ch.ann.compose.body', '/announcements', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.ann.compose.panel.title', 'tour.ch.ann.compose.panel.body', '/announcements', {
        placement: 'left',
        openSlideOver: 'compose-announcement',
      }),
      s('[data-tour="announcements-tabs"]', 'tour.ch.ann.tabs.title', 'tour.ch.ann.tabs.body', '/announcements', { placement: 'bottom' }),
      s('[data-tour="announcements-list"]', 'tour.ch.ann.list.title', 'tour.ch.ann.list.body', '/announcements', { placement: 'right' }),
    ],
  },
  {
    id: 'owner.messages',
    titleKey: 'messages',
    route: '/messages',
    useSampleData: true,
    steps: [
      s('[data-tour="messages-filters"]', 'tour.ch.messages.filters.title', 'tour.ch.messages.filters.body', '/messages', { placement: 'bottom' }),
      s('[data-tour="messages-contacts"]', 'tour.ch.messages.contacts.title', 'tour.ch.messages.contacts.body', '/messages', { placement: 'right' }),
      s('[data-tour="messages-thread"]', 'tour.ch.messages.thread.title', 'tour.ch.messages.thread.body', '/messages', { placement: 'left' }),
    ],
  },
  {
    id: 'owner.employees',
    titleKey: 'employees',
    route: '/employees',
    useSampleData: true,
    steps: [
      s('[data-tour="employees-invite"]', 'tour.ch.employees.invite.title', 'tour.ch.employees.invite.body', '/employees', { placement: 'bottom' }),
      s('[data-tour="employees-card"]', 'tour.ch.employees.card.title', 'tour.ch.employees.card.body', '/employees', { placement: 'top' }),
      s('[data-tour="employees-edit"]', 'tour.ch.employees.edit.title', 'tour.ch.employees.edit.body', '/employees', { placement: 'left' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.employees.edit.panel.title', 'tour.ch.employees.edit.panel.body', '/employees', {
        placement: 'left',
        openSlideOver: 'employee-edit',
      }),
    ],
  },
  {
    id: 'owner.managers',
    titleKey: 'managers',
    route: '/managers',
    useSampleData: true,
    steps: [
      s('[data-tour="managers-invite"]', 'tour.ch.managers.invite.title', 'tour.ch.managers.invite.body', '/managers', { placement: 'bottom' }),
      s('[data-tour="managers-card"]', 'tour.ch.managers.card.title', 'tour.ch.managers.card.body', '/managers', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.contracts',
    titleKey: 'contracts',
    route: '/contracts',
    useSampleData: true,
    steps: [
      s('[data-tour="contracts-filters"]', 'tour.ch.contracts.filters.title', 'tour.ch.contracts.filters.body', '/contracts', { placement: 'bottom' }),
      s('[data-tour="contracts-send"]', 'tour.ch.contracts.send.title', 'tour.ch.contracts.send.body', '/contracts', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.contracts.send.panel.title', 'tour.ch.contracts.send.panel.body', '/contracts', {
        placement: 'left',
        openSlideOver: 'send-contract',
      }),
      s('[data-tour="contracts-list"]', 'tour.ch.contracts.list.title', 'tour.ch.contracts.list.body', '/contracts', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.workplaces',
    titleKey: 'workplaces',
    route: '/workplaces',
    useSampleData: true,
    steps: [
      s('[data-tour="workplaces-add"]', 'tour.ch.workplaces.add.title', 'tour.ch.workplaces.add.body', '/workplaces', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.workplaces.add.panel.title', 'tour.ch.workplaces.add.panel.body', '/workplaces', {
        placement: 'left',
        openSlideOver: 'workplace-form',
      }),
      s('[data-tour="workplaces-grid"]', 'tour.ch.workplaces.grid.title', 'tour.ch.workplaces.grid.body', '/workplaces', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.positions',
    titleKey: 'positions',
    route: '/positions',
    useSampleData: true,
    steps: [
      s('[data-tour="positions-add"]', 'tour.ch.positions.add.title', 'tour.ch.positions.add.body', '/positions', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.positions.add.panel.title', 'tour.ch.positions.add.panel.body', '/positions', {
        placement: 'left',
        openSlideOver: 'position-form',
      }),
      s('[data-tour="positions-grid"]', 'tour.ch.positions.grid.title', 'tour.ch.positions.grid.body', '/positions', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.jobs',
    titleKey: 'job.board',
    route: '/job-board',
    useSampleData: true,
    steps: [
      s('[data-tour="jobboard-create"]', 'tour.ch.jobs.create.title', 'tour.ch.jobs.create.body', '/job-board', { placement: 'bottom' }),
      s('[data-tour="tour-slide-over"]', 'tour.ch.jobs.create.panel.title', 'tour.ch.jobs.create.panel.body', '/job-board', {
        placement: 'left',
        openSlideOver: 'job-form',
      }),
      s('[data-tour="jobboard-applications"]', 'tour.ch.jobs.apps.title', 'tour.ch.jobs.apps.body', '/job-board', { placement: 'bottom' }),
      s('[data-tour="jobboard-view"]', 'tour.ch.jobs.view.title', 'tour.ch.jobs.view.body', '/job-board', { placement: 'bottom' }),
    ],
  },
  {
    id: 'owner.job-applications',
    titleKey: 'job.applications',
    route: '/job-applications',
    useSampleData: true,
    steps: [
      s('[data-tour="jobapps-grid"]', 'tour.ch.jobapps.grid.title', 'tour.ch.jobapps.grid.body', '/job-applications', { placement: 'top' }),
      s('[data-tour="jobapps-actions"]', 'tour.ch.jobapps.actions.title', 'tour.ch.jobapps.actions.body', '/job-applications', { placement: 'left' }),
    ],
  },
  {
    id: 'owner.activity',
    titleKey: 'recent.activity',
    route: '/recent-activity',
    useSampleData: true,
    steps: [
      s('[data-tour="activity-view"]', 'tour.ch.activity.view.title', 'tour.ch.activity.view.body', '/recent-activity', { placement: 'bottom' }),
      s('[data-tour="activity-filters"]', 'tour.ch.activity.filters.title', 'tour.ch.activity.filters.body', '/recent-activity', { placement: 'bottom' }),
      s('[data-tour="activity-feed"]', 'tour.ch.activity.feed.title', 'tour.ch.activity.feed.body', '/recent-activity', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.settings',
    titleKey: 'settings',
    route: '/settings',
    useSampleData: true,
    steps: [
      s('[data-tour="settings-tabs"]', 'tour.ch.settings.tabs.title', 'tour.ch.settings.tabs.body', '/settings', { placement: 'bottom' }),
      s('[data-tour="settings-notifications"]', 'tour.ch.settings.prefs.title', 'tour.ch.settings.prefs.body', '/settings?tab=preferences', { placement: 'top' }),
      s('[data-tour="settings-credits"]', 'tour.ch.settings.billing.title', 'tour.ch.settings.billing.body', '/settings?tab=billing', { placement: 'top' }),
    ],
  },
  {
    id: 'owner.help',
    titleKey: 'tour.help',
    route: '/dashboard',
    useSampleData: true,
    steps: [
      s('[data-tour="help"]', 'tour.ch.help.title', 'tour.ch.help.body', '/dashboard', { placement: 'right' }),
      s('[data-tour="replay-tour"]', 'tour.ch.help.replay.title', 'tour.ch.help.replay.body', '/settings?tab=preferences', { placement: 'top' }),
    ],
  },
];
